import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
export const DefaultLinkSimple = forwardRef((_a, ref) => {
    var { children, href = '', rel: initialRel, target } = _a, otherProps = __rest(_a, ["children", "href", "rel", "target"]);
    const initialRelProps = initialRel ? ` ${initialRel}` : '';
    const isTargetBlank = target === '_blank';
    const rel = isTargetBlank
        ? `noopener noreferrer${initialRelProps}`
        : initialRel;
    return (_jsx("a", Object.assign({}, otherProps, { "data-testid": "default-link-element", href: href, ref: ref, rel: rel, target: target, children: children })));
});
//# sourceMappingURL=DefaultLinkSimple.js.map